<template>
<div class="chapter">
<div class="inner_page">
<h3 class="P_TOC_Heading"><a id="tableofcontents">Table of Contents</a></h3><a id="tableofcontents">
</a><p class="P_TOC_Entry_1"><a id="tableofcontents"></a><a href="#/section0001">Excerpt</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0002">The Bad Boy Next Door</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004">Chapter 1</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005">Chapter 2</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0006" title="Link target outside of Sample">Chapter 3</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0007" title="Link target outside of Sample">Chapter 4</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0008" title="Link target outside of Sample">Chapter 5</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0009" title="Link target outside of Sample">Preview the next book</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010" title="Link target outside of Sample">Note from Lexxie</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011" title="Link target outside of Sample">eBooks by Lexxie Couper</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012" title="Link target outside of Sample">Lexxie recommends … Dakota Cassidy</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TableOfContents.vue?09964af0